import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const domainReportApi = createApi({
  reducerPath: 'domainReportApi',
  baseQuery: fetchBaseQuery({
    credentials: 'include',
  }),
  tagTypes: ['DomainReport'],
  endpoints: (builder) => ({
    requestDomainReport: builder.mutation({
      query: (customerEmail) => ({
        url: '/api/domain-report-request',
        method: 'POST',
        body: { customer_email: customerEmail },
      }),
      transformErrorResponse: (response, meta) => ({
        ...response,
        xRequestId: meta && meta.response ? meta.response.headers.get('x-request-id') : undefined,
      }),
    }),
  }),
});

export const { useRequestDomainReportMutation } = domainReportApi;
